<template>
  <div id="container">
    <transition :name="mainTransitionName" mode="out-in">
      <div id="videoContainer" v-show="isVideoVisible">
        <div class="w-full">

          <iframe
            :src="`/pdfjs/web/viewer.html?file=${pdfFileUrl}#toolbar=0&navpanes=0`"
            style="height: 100%; width: 100%"
            frameborder="0"
            scrolling="0"
          ></iframe>
          
        </div>

        <span class="video-watermark dark">{{
          personalInfo ? personalInfo.userId : ""
        }}</span>
        <span class="video-watermark light">{{
          personalInfo ? personalInfo.userId : ""
        }}</span>
        <div class="d-landscape-block d-portrait-none lesson-name t-body4">
          {{ lessonName }}
        </div>
        <div id="imageInfo" class="d-landscape-none">
          <span class="typography--b5">{{ currentSlide }} / </span>
          <span class="color-secondary">{{ slideFiles.length }}</span>
        </div>
        <button @click="moveLearnView()" id="btnClose"></button>
        <button
          @click="moveQuestion()"
          id="btnQnA"
          class="d-landscape-none"
        ></button>
        <button
          @click="onScrollClick()"
          id="btnPaging"
          class="d-landscape-none"
        >
          <span>
            {{ $t("1117") }}
            <!-- Paging -->
          </span>
        </button>
      </div>
    </transition>

    <!-- 버튼 영역 -->
    <transition :name="mainTransitionName" mode="out-in">
      <div
        v-show="isVideoVisible"
        class="d-portrait-none"
        id="videoButtonsContainer"
      >
        <button @click="onToggleAllPages()" class="typography--b3 allpages">
          {{ $t("1052") }}
          <!-- All Pages -->
        </button>
        <button @click="moveQuestion()" class="typography--b3">
          {{ $t("1053") }}
          <!-- Ask a question -->
        </button>
        <button @click="onTogglePlaylist()" class="typography--b3">
          {{ $t("1054") }}
          <!-- Lectures -->
        </button>
      </div>
    </transition>

    <!-- 진도율 / 좋아요 / 북마크 영역 -->
    <transition :name="mainTransitionName" mode="out-in">
      <div v-show="isVideoVisible" id="mainContainer" class="d-landscape-none">
        <div id="videoDetails">
          <span class="typography--s4 d-block mt-3">{{ lessonName }}</span>
          <span class="typography--b7 d-block mt-2 color-secondary"
            >{{ rate }} %</span
          >
        </div>

        <like-and-bookmark
          :likesCount="likesCount"
          :clippingCount="clippingCount"
          :likes="likes"
          :clipping="clipping"
          @updateLikesCount="updateLikesCount"
          @updateBookmarkCount="updateBookmarkCount"
        ></like-and-bookmark>
      </div>
    </transition>

    <div id="resizeContainer">
      <div></div>
    </div>

    <!-- 차시 목록 영역 -->
    <transition :name="mainTransitionName" mode="out-in">
      <div v-show="isLecturesVisible" id="playlistContainer">
        <div class="title">
          <button @click="onTogglePlaylist()" id="btnPlaylistClose"></button>
          <span
            class="typography--s4 text-center"
            :class="{
              'typography--b4': !showLectureList,
              'text-left': !showLectureList,
            }"
          >
            {{ !nextLessonData ? $t("1999") : showLectureList ? "Lectures" : `Next: ${nextLessonName}` }}
          </span>
          <i class="material-icons" id="btnPlaylistToggle" @click="onTogglePlaylist()">expand_less</i>
          <div class="clearfix"></div>
        </div>
        <div class="lectures-list">
          <lessons-list
            :lessonsList="lessonsList"
            :currentProgressionId="currentProgressionId"
          ></lessons-list>
        </div>
      </div>
    </transition>

    <!-- {{lessonData}} -->
  </div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - PDF 컨텐츠 컴포넌트(my learning lesson study - PDF content component)
 *
 * @author minkyoung.park@emcast.com
 */
// Components/Mixin/Extend/API define
import learnApi from "@/api/learnApi.js";
import ImageSlider from "./slider/ImageSlider.vue";
import { slideTypeMixins } from "../../mixins/slideType.js";
import LikeAndBookmark from "./LikeAndBookmark.vue";
import LessonsList from "./LessonsList.vue";
import { captureApiError } from "@/utils/sentryApiHandler.js"
import { updateLearnProgression } from "@/utils/learnProgressionUtil.js";

export default {
  data() {
    return {
      pdfFileUrl: "",
      slideFiles: [],
      lessonData: null,
      lessonName: "",
      lessonsList: [],
      nextLessonName: "",
      currentProgressionId: "",
      rate: 0,
      last: 0,
      recent: 0,
      time: 0,
      currentSlide: 0,
      showLectureList: false,

      // 북마크 좋아요 관려 데이터(like & bookmark data)
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,

      isAllPages: false,
      isScroll: false,
      isTimeline: false,
      isExpand: false,

      personalInfo: null,
    };
  },

  components: {
    "lessons-list": LessonsList,
    "like-and-bookmark": LikeAndBookmark,
  },

  mixins: [slideTypeMixins],

  computed: {},

  mounted() {
    let params = this.setParams();
    let responseData = null;
    console.log("params", this.$route.params);

    //차시 컨텐츠 정보 API 호출(get lesson contents data)
    learnApi
      .learnLessonContents(params)
      .then((response) => {
        responseData = response.data.data;

        this.lessonData = responseData;
        this.lessonName = this.lessonData.lessonName;
        this.rate = this.lessonData.rate;
        this.pdfFileUrl = this.lessonData.pdf.file;
        this.last = this.lessonData.last;
        this.recent = this.lessonData.recent;
        this.currentProgressionId = this.lessonData.progressionId;
        // this.time = this.lessonData.slide.time

        this.likes = this.lessonData.likes;
        this.likesCount = this.lessonData.likesCount;
        this.clipping = this.lessonData.clipping;
        this.clippingCount = this.lessonData.clippingCount;

        // 화면 로드 완료 후 진도저장(Save progress after loading the screen)
        this.updateProgress();
      })
      .catch((err) => {
        captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
      });

    learnApi.getMemberInfo().then((response) => {
      this.personalInfo = response.data.data;
    }).catch((err) => {
      captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
    });
    // 차시목록 호출
    this.fetchLectureList();
  },
  methods: {
    // 진도저장 API 호출(update progress)
    updateProgress() {
      let params = this.setParams();
      let responseData = null;

      if (this.rate <= 100) {
        updateLearnProgression({ params, vueThis: this })
          .then((response) => {
            if (response) {
              responseData = response.data.data;
              this.rate = responseData.rate;
              this.last = responseData.last;
            }
          })
          .catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
          });
      }
    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: 1,
        current: 1,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },

    // update likes count
    updateLikesCount(data) {
      this.likes = data.likes;
      this.likesCount = data.likesCount;
    },

    // update bookmark count
    updateBookmarkCount(data) {
      this.clipping = data.clipping;
      this.clippingCount = data.clippingCount;
    },

    // 학습 목록 API 호출(get lesson list)
    fetchLectureList() {
      // console.log('fetchLectureList');
      let responseData = null;
      let params = this.setParams();

      //차시 정보
      learnApi
        .learnViewCourses(params)
        .then((response) => {
          // 과정의 차시 정보만 병합(Merging only lesson data from the course)
          _.each(response.data.data, (course) => {
            this.lessonsList = this.lessonsList.concat(course.lessons);
          });

          // 다음 차시명 설정(set next lesson)
          let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
            return lesson.progressionId === this.currentProgressionId;
          });
          let nextLessonIndex =
            this.lessonsList.length > 1 &&
            this.lessonsList.length > currentLessonIndex
              ? (currentLessonIndex += 1)
              : -1;
          if (nextLessonIndex) {
            this.nextLesson = this.lessonsList[nextLessonIndex];
            if (this.nextLesson) this.nextLessonName = this.lessonsList[nextLessonIndex].name;
          }
        })
        .catch((err) => {
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });
    },

    //나의 학습 상세로 이동(Go to my learning details)
    moveLearnView() {
      let goBackBookMarkLessson = localStorage.getItem("videoBookMarkLesson");
      let goBackLikeLessson = localStorage.getItem("videoLikeLesson");
      if (goBackBookMarkLessson == "setVideoBookMarkLesson") {
        localStorage.removeItem("videoBookMarkLesson");
        this.$router.push({
          name: "BookMarkedLesson",
        });
      } else if (goBackLikeLessson == "setVideoLikeLesson") {
        localStorage.removeItem("videoLikeLesson");
        this.$router.push({
          name: "LikedLesson",
        });
      } else {
        this.$router.push({
          name: "LearnView",
          params: { learnId: this.$route.params.learnId },
          query: this.$route.query,
        });
      }
      // this.$router.push({
      //     name: 'LearnView',
      //     params: {learnId: this.$route.params.learnId},
      //     query: this.$route.query
      // })
    },

    // 질문하기로 이동(Go to Ask a Question)
    moveQuestion() {
      this.$router.push({
        name: "LessonViewQuestion",
        query: this.$route.query,
      });
    },
  },
};
</script>
<style scoped src="../../css/pdf.css"></style>
<style scoped>
#playlistContainer.show {
  z-index: 999;
}
span.video-watermark {
  position: absolute;
  /* left: 20px; */
  font-size: 12px;
  transform: rotate(-45deg);
  opacity: 0.25;
  cursor: none;
  z-index: 999;
}
span.video-watermark.light {
  color: #fff;
  top: 50%;
  left: 40%;
  transform: translate(-40%, -50%) rotate(-45deg);
}
span.video-watermark.dark {
  color: #000000;
  top: 50%;
  left: 51%;
  transform: translate(-51%, -50%) rotate(-45deg);
}
@media (min-width: 480px) {
  span.video-watermark.light {
    left: 45%;
    transform: translateX(-45%) rotate(-45deg);
  }
}
</style>
